import React, { useEffect, useState, useRef } from 'react';
import { Link } from "react-router-dom";
import "../tabs/css/Projects.css";
import ConfirmationModal from "../components/ConfirmationModal";

// Projects that live on this site instead of an external link (matched by the URL stored in the backend)
const INTERNAL_ROUTES = {
    'https://github.com/Felippefn/Password-gen': '/password-generator',
};

const getInternalRoute = (project) => {
    if (project.github?.startsWith('/')) return project.github;
    return INTERNAL_ROUTES[project.github?.replace(/\/+$/, '')];
};

const Projects = () => {
    const [projects, setProjects] = useState([]);
    const [status, setStatus] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const res = await fetch('https://website-backend-production-2163.up.railway.app/api/projects'); // Adjust this URL to match your backend
                const data = await res.json();
                setProjects(data.reverse());
            } catch (err) {
                console.error('Failed to fetch projects:', err);
            }
        };

        fetchProjects();
    }, []);



        const formRef = useRef();
    
        const sendEmail = async (e) => {
        e.preventDefault();
    
        const formData = new FormData(formRef.current);
        const data = Object.fromEntries(formData.entries());
    
        try {
            const response = await fetch("https://website-backend-production-2163.up.railway.app/api/email/send-email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });
    
            if (response.ok) {
                setStatus("success");
                formRef.current.reset();
            } else {
                setStatus("error");
            }
        } catch (error) {
            console.error("Error sending message:", error);
            setStatus("error");
        }
        };


    return (
        <section className="projects-section">
            <Link to="/" className="home-button-gaming2" >
            Go to Home
            </Link>
            <h1 className="projects-heading">Projects - FN Studios</h1>
            <div className="projects-grid">
                {projects.map((project) => (
                    <div className="project-card" key={project._id}>
                    <div className="project-img-wrapper">
                        <img
                            src={project.imageUrl || "Designer3DFNKeycap.png"}
                            alt={project.title}
                            className="project-image"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "Designer3DFNKeycap.png";
                            }}
                        />
                    </div>
                    <h2 className="project-title">{project.title || 'No title found'}</h2>
                    <div className="project-body">
                        <p className="project-text">{project.text}</p>
                        <div className="project-links">
                            {getInternalRoute(project) ? (
                                <Link to={getInternalRoute(project)} className="project-button">
                                    View Project
                                </Link>
                            ) : (
                                <a
                                    href={project.github}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="project-button"
                                >
                                    View Project
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                ))}
            </div>

            <div className="contact-form-box">
                    <h3>Send me a message</h3>
                    <form ref={formRef} className="contact-form" onSubmit={sendEmail}>
                        <input type="text" name="name" placeholder="Your Name" required />
                        <input type="email" name="user_email" placeholder="Your Email" required />

                        <select name="reason" required>
                            <option value="">Select Reason</option>
                            <option value="Ask for a service">Ask for a service</option>
                            <option value="General contact">General contact</option>
                            <option value="Feedback">Feedback</option>
                        </select>

                        <textarea name="message" placeholder="Describe your message..." rows="5" required></textarea>

                        <button type="submit">Send Message</button>
                    </form>
                </div>

             <footer className="main-page-footer">
        <p>© 2025 FN Studios. All rights reserved.</p>
      </footer>

      <ConfirmationModal
        status={status}
        onClose={() => setStatus(null)}
        onContinue={() => setStatus(null)}
      />
        </section>

    );
};

export default Projects;
